angular.module('shared').factory('roundMinutes', function() {
  return function(time, interval) {
    var remainder;
    remainder = (interval - time.minute()) % interval;
    if (remainder < 0) {
      remainder += interval;
    }
    return moment(time).add(remainder, "minutes").set({
      'second': 0
    });
  };
});
